module.exports = __webpack_public_path__ + "static/media/shapes-ellipse.4b00785f.svg";